import { getAccessDevMode } from '@nexxt/common/firebase/auth/userDetails';
import { PROJECT_EDIT_STATUS, VIEW_MODE } from '@nexxt/common/types';
import actionTypes from '../actions/actionTypes';
import actionType from '../actions/actionTypes';

export interface IUtilsReducer {
    isEdited: boolean;
    editedType: string;
    editStatus: PROJECT_EDIT_STATUS;
    // Header sidebar
    isSidebarExpand: boolean;

    // user dropdown
    showDropdown: boolean;

    viewMode: string;
}

const initialState: IUtilsReducer = {
    isEdited: false,
    editedType: '', // "question|questionId"//project|projectId
    isSidebarExpand: true,
    showDropdown: false,
    viewMode: getAccessDevMode() ? VIEW_MODE.DEV : '',
    editStatus: PROJECT_EDIT_STATUS.COMPLETED
};

export default function (
    state: IUtilsReducer = initialState,
    action
): IUtilsReducer {
    switch (action.type) {
        case actionType.SET_EDITED_STATUS:
            let isEdited = true;
            if (state.editStatus === action?.payload?.editStatus)
                return { ...state };
            if (
                [PROJECT_EDIT_STATUS.EDIT_REQUIRED].includes(
                    action.payload.editStatus
                )
            ) {
                isEdited = false;
            }
            return {
                ...state,
                isEdited,
                editStatus: action.payload?.editStatus,
                editedType: action.payload.editedType
            };
        case actionType.CLEAR_EDITED_STATUS:
            return {
                ...initialState,
                editStatus: action.payload?.status,
                viewMode: state.viewMode
            };
        // header
        case actionType.SIDEBAR_TOGGLE:
            if (state.isSidebarExpand === action.paylod) return;
            return {
                ...state,
                isSidebarExpand: action.payload
            };

        case actionType.USER_DROPDOWN_SHOW:
            return {
                ...state,
                showDropdown: true
            };

        // User dropdown
        case actionType.USER_DROPDOWN_HIDE:
            return {
                ...state,
                showDropdown: false
            };
        case actionTypes.SET_VIEW_MODE:
            const viewMode = getAccessDevMode() ? VIEW_MODE.DEV : '';
            return {
                ...state,
                viewMode
            };

        case actionType.CLEAR_STATE:
            return {
                ...initialState
            };

        default:
            return state;
    }
}
